import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';

import { tokenStore } from '../../shared/api/tokens';
import { Spinner } from '../../shared/ui/primitives';
import type { Role } from './api';
import { useSession } from './session';

function Loading() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <Spinner />
    </div>
  );
}

/** Пускает дальше только при валидной сессии, иначе — на /login. Исходный
 *  адрес передаётся в state.from: после входа LoginPage вернёт туда (например,
 *  по ссылке на обследование из письма). */
export function AuthGuard({ children }: { children: ReactNode }) {
  const { hasToken, isLoading, isError } = useSession();
  const location = useLocation();
  const from = location.pathname + location.search;

  if (!hasToken) return <Navigate to="/login" replace state={{ from }} />;
  if (isLoading) return <Loading />;
  if (isError) {
    tokenStore.clear();
    return <Navigate to="/login" replace state={{ from }} />;
  }
  return <>{children}</>;
}

/** Ограничивает доступ по роли; при несоответствии — на /patients. */
export function RoleGuard({ allow, children }: { allow: Role[]; children: ReactNode }) {
  const { user } = useSession();
  if (!user) return <Loading />;
  if (!allow.includes(user.role)) return <Navigate to="/patients" replace />;
  return <>{children}</>;
}
